module.exports = __webpack_public_path__ + "static/media/search.js.5f47bcc5.txt";